import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';

import { TicketQuotaMessageService } from "../../../../components/event-components/ticket-quota-collection/ticket-quota-message-service"
import * as model from "../../../../models";
import * as ui from "../../../../models/ui";
import { NumberField } from '../../../../ui-helper';

interface TicketQuotaMessageEditorActionsWithControl extends ui.TicketQuotaMessageEditorAction {
	ticketQuotaControl: FormControl;
}

@Component({
	selector: 'ticket-quota-message-editor',
	templateUrl: "./ticket-quota-message-editor.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles:[require("./ticket-quota-message-editor.scss")]
})

export class TicketQuotaMessageEditor {
	private _ticketQuotaMessageEditorActions: TicketQuotaMessageEditorActionsWithControl[]

	private commentControl: FormControl

sortArray(array){
	array.sort((a,b) => a.category.type.localeCompare(b.category.type));
}

	@Input() private displayButtons: boolean

	@Input() set ticketQuotaMessageEditorActions(ticketQuotaMessageEditorActions: ui.TicketQuotaMessageEditorAction[]) {
		this.sortArray(ticketQuotaMessageEditorActions);
		this._ticketQuotaMessageEditorActions = ticketQuotaMessageEditorActions.map(tqmea => Object.assign({}, tqmea, {
			ticketQuotaControl: new FormControl("")
		}));
		this.commentControl = new FormControl("")
	}

	@Output() ticketQuotaMessageSave: EventEmitter<model.TicketQuotaMessage> = new EventEmitter<model.TicketQuotaMessage>();

	get ticketQuotaMessageEditorActions() {
		return this._ticketQuotaMessageEditorActions
	}

	constructor(private ticketQuotaMessageService: TicketQuotaMessageService) {}

	formSaved() {
		const liste: ui.TicketQuotaMessageEditorAction[] = this._ticketQuotaMessageEditorActions.map(tqmea => Object.assign({}, tqmea, {
			numberOfTicketsToAddDelete: parseInt(tqmea.ticketQuotaControl.value)
		}))
		if(liste.every(action => isNaN(action.numberOfTicketsToAddDelete))){
			//suppress submit
			return;
		}

		const ticketQuotaMessage: model.TicketQuotaMessage = this.ticketQuotaMessageService.createTicketQuotaMessage({ comment: this.commentControl.value, ticketQuotaMessageEditorActions: liste })

		this.ticketQuotaMessageSave.emit(ticketQuotaMessage)
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-quota-collection/ticket-quota-message-editor/ticket-quota-message-editor.component.ts